import { CustomLink } from ".."
import { Assets } from "../styles/assets"
import { BtnRedOutlineStyle, BtnRedStyle, Loading } from "./style"

type Props = {
    children: React.ReactNode,
    disabled?: boolean,
    loading?: boolean,
    width?: string,
    height?: string,
    margintop?: string,
    marginbottom?: string
    onClick?: () => void
    goToPage?: string    
}

export const ButtonRedOutline = ({
    children,
    disabled,
    loading,
    width,
    height,
    margintop,
    marginbottom,
    onClick,
    goToPage,    
}: Props) => {
    const Button = () => (
        <BtnRedOutlineStyle
            disabled={loading || disabled}
            width={width}
            height={height}
            margintop={margintop}
            marginbottom={marginbottom}            
            type={onClick ? "button" : "submit"}
            onClick={onClick}
        >
            {children}
            {loading && <Loading src={Assets.loadingBlack} alt="loading" />}
        </BtnRedOutlineStyle>
    )

    return (
        goToPage ? <CustomLink to={goToPage} width={width}><Button /></CustomLink> : <Button />
    )
}